var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_914_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_914_6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_914_6",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_914_6",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAETElEQVR4nO2cv28URxTHp8oPiVDyQ9AhURIogHS4QT5mjCXr5tmgizj5vbMVIkVRGlKCUkWipMDCorBwmlhKRG+LEoj4C6JI/IoSLEQBwklAchzNnSH3Y/e8e7e7s3v7/UjbWHOzO+/Ne/fd9+asFAAAAAAAAAAAAAAAGVKZahzUxCua5JUh2UrzcvfQJD+dmWkchpNVy/iG+EXahu+9+IW7d+mdoIlXsjf+++tHOIDSTzuhl5WXpXeA8bf7mxccQHCAVwwcAAeUGoMIgANKjUEEwAGlxiAC4IBSYxABcAAAAABQSjTJG39KiP9RZUdbfu7RAeuq7GjLv/hrSfJdVXa0lRseI2BBlR1NjfO+HKBpdlqVnclJ/kQTb2RvfN4g+nKX7/XnAm3lpof0s+h73bnhzEzjsLH8NrvdL28qM/OHfK87VxgrVzPb/Va+973e3HGqXv/IycIMUs8DIvrY93pziab6Pm3lSYrG/8PQhQO+15lrzPTsp5rk9xSM//RsVY74Xl8hGJ+a329I7iWX8/mum9P3ugr3naAtf2esvB7C8G/dF66by/d6Csv41Px+beV6rJe1ptN4EVIz4TfmCZIZV79ppSded3q+Vc7m9e2/LbjyAt5wAQAAAAAAACBBDPG3YW/A2vJlGHtIxiMUzQzJlQAHXEli7vI2Y4jnXNWyVV6o79vpM4Z4ra3UvBap1+DKFs2mD8+hQKeUcp0pl1K05Wdxd3OrufJ/oyVu1DTvaeVSabtjxvK5Pt2vP4nog75N/K7P9Pv/P24uN2fg9wbx41KdDzp7TvZqktsRavm1sDma6aq34zUXOt5ybaf7aSs/n576Yo8aZTQ1jhqSRxFbiA/C55HlAIfdCh/P96Pc07VCJ6bnjquRTTkxT8Dp6uzJoLmCUxc/DRpbmW58Fq+LJn8bkroaJTTJN4O0FDXJcvdcrssVNj6oAxYYLdEi8Gs1ChhiNiT/DmQE607LdR4j2Z4vcPyEldmedubgPwBxz3xRFV/p8OaABtgKkqSaZKlPxCxFeGGLHoGWN10bVBURdwYnmVPPvF6pfPXhu3n7folbeRhFesZMg39VqnxMFYlKrbbbWP5teONLjyTVxHfCjcV34kjPGE74tVCNfneMJDHjU6ckNVUZCx1XlbG40jO6E/iaKgKG5EQCeX+rnyQNioL23e/GJn7/1ppOqLyjSVaTXrzpkqSBUdC2+w3xDyk9w6rKO2ks3ARI0vYoaN/9Q0rPHS9VWgdQpyTtiIKO3T+c9IQDKLokdTu/ffcnJT0RARRNkjajoH33Jyg9kYJokCppr/RMOoWqvJP2DjQhVdKwqmfSz6/yTiYOoN4qaZj0TPr5Vd7JwgGmS5L2k55JP7/KO5k4gLokacrSEw6gcEmahfSEAyg0FdU0yecZRh1SkOk0yL1Ef84KB0hmhoQDcmBMgwgQ7wZFCqJiXX5FPgAAAAAAAECNAP8BituLcXgwJ7oAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrationIcon);
export default __webpack_public_path__ + "static/media/administration-icon.be9b7c3594c405b829fd7593852c2801.svg";
export { ForwardRef as ReactComponent };